import { render, staticRenderFns } from "./FirstCourse.vue?vue&type=template&id=738016fb&scoped=true"
import script from "./FirstCourse.vue?vue&type=script&lang=js"
export * from "./FirstCourse.vue?vue&type=script&lang=js"
import style0 from "./FirstCourse.vue?vue&type=style&index=0&id=738016fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738016fb",
  null
  
)

export default component.exports